// extracted by mini-css-extract-plugin
export var actions = "_lr-g";
export var benefitCard = "_lr-b";
export var benefitIcon = "_lr-d";
export var benefitLabel = "_lr-f";
export var benefits = "_lr-a";
export var benefitsSection = "_lr-8";
export var bodyText = "_lr-7";
export var closeButton = "_lr-2";
export var content = "_lr-3";
export var eyebrow = "_lr-4";
export var heading = "_lr-5";
export var image = "_lr-i";
export var imagePanel = "_lr-h";
export var modal = "_lr-0";
export var offerCard = "_lr-c";
export var offerIcon = "_lr-e";
export var sectionLabel = "_lr-9";
export var shell = "_lr-1";
export var title = "_lr-6";